'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $('[data-click-on-enter]', this).on('keyup', function (e) {
        if (e.keyCode === 13) {
            var target = $(this).attr('data-click-on-enter');
            $(target).trigger('click');
            return false;
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/click-on-enter.js
// module id = 1128
// module chunks = 0